import api from './index'

export function getPublicHolidays(year) {
  return api.get('/api/v1/business-calendar/public-holidays', { params: { year } })
}

export function createPublicHoliday(data) {
  return api.post('/api/v1/business-calendar/public-holidays', data)
}

export function updatePublicHoliday(holidayCode, data) {
  return api.put(`/api/v1/business-calendar/public-holidays/${holidayCode}`, data)
}

export function deletePublicHoliday(holidayCode) {
  return api.delete(`/api/v1/business-calendar/public-holidays/${holidayCode}`)
}

export function getBranchCalendar(branchCode, year) {
  return api.get(`/api/v1/business-calendar/branches/${branchCode}`, { params: { year } })
}

export function saveWeeklyRules(branchCode, data) {
  return api.put(`/api/v1/business-calendar/branches/${branchCode}/weekly-rules`, data)
}

export function createDateOverride(branchCode, data) {
  return api.post(`/api/v1/business-calendar/branches/${branchCode}/date-overrides`, data)
}

export function updateDateOverride(branchCode, overrideCode, data) {
  return api.put(`/api/v1/business-calendar/branches/${branchCode}/date-overrides/${overrideCode}`, data)
}

export function deleteDateOverride(branchCode, overrideCode) {
  return api.delete(`/api/v1/business-calendar/branches/${branchCode}/date-overrides/${overrideCode}`)
}

export function copyBusinessCalendar(data) {
  return api.post('/api/v1/business-calendar/copy', data)
}
